import classNames from "classnames";
import { FC } from "react";
import PauseIcon from "@svg/player/Pause";
import PlayIcon from "@svg/player/Play";

interface Props {
  isPlaying: boolean;
  animatePlay: boolean;
  isControlsVisible: boolean | undefined;
}

const iconSize = "56%";
const CenteredPlayButton: FC<Props> = ({
  isPlaying,
  animatePlay,
  isControlsVisible,
}) => {
  const RenderPlayIcon = isPlaying ? PauseIcon : PlayIcon;
  const RenderPlayAnimationIcon = isPlaying ? PlayIcon : PauseIcon;

  return animatePlay ? (
    <div
      className={classNames(
        "nplay-playback-animation animate-ping-play-centered",
        isControlsVisible === undefined ? "opacity-100" : "opacity-0 scale-1"
      )}
    >
      <RenderPlayAnimationIcon
        width={iconSize}
        height={iconSize}
        className={isPlaying ? "ml-1" : "ml-0"}
        fill="#F5F5F5"
      />
    </div>
  ) : (
    <div
      className={classNames(
        "nplay-playback-animation",
        isControlsVisible === undefined ? "opacity-100" : "opacity-0 scale-1"
      )}
    >
      <span className="nplay-playback-tooltip">پخش</span>
      <RenderPlayIcon
        width={iconSize}
        height={iconSize}
        className="ml-1"
        fill="#F5F5F5"
      />
    </div>
  );
};

export default CenteredPlayButton;
